<ng-container [ngSwitch]="viewModeService.viewMode$ | async">
  <ng-container *ngSwitchCase="'modal'">
    <div [ngClass]="{ 'inbox-modal': viewModeService.isOpen$ | async }">
      <ng-container *ngTemplateOutlet="inboxOutlet"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'sidebar'">
    <mat-sidenav-container [hasBackdrop]="false">
      <mat-sidenav
        class="inbox-sidebar"
        [mode]="modeType"
        position="end"
        disableClose="true"
        [autoFocus]="false"
        [opened]="viewModeService.isDrawerOpen$ | async"
      >
        <div class="container">
          <ng-container *ngTemplateOutlet="inboxOutlet"></ng-container>
        </div>
      </mat-sidenav>

      <mat-sidenav-content>
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </ng-container>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>

<ng-template #inboxOutlet>
  <router-outlet name="inbox"></router-outlet>
</ng-template>
